import { render, staticRenderFns } from "./PromotionForm.vue?vue&type=template&id=23d84862&scoped=true&"
import script from "./PromotionForm.vue?vue&type=script&lang=js&"
export * from "./PromotionForm.vue?vue&type=script&lang=js&"
import style0 from "./PromotionForm.vue?vue&type=style&index=0&id=23d84862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d84862",
  null
  
)

export default component.exports